import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

export type EventqBadgeVariant = 'count' | 'status' | 'live';
export type EventqStatus = 'critical' | 'warning' | 'info' | 'success' | 'neutral';

@Component({
  selector: 'eventq-badge',
  templateUrl: './badge.html',
  styleUrl: './badge.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EventqBadge {
  readonly variant = input<EventqBadgeVariant>('status');
  readonly label = input('LIVE');
  readonly status = input<EventqStatus>('neutral');
  readonly count = input<number>();
  readonly max = input(99);

  readonly displayText = computed(() => {
    if (this.variant() === 'count') {
      const value = this.count() ?? 0;
      const max = this.max();
      return value > max ? `${max}+` : String(value);
    }
    return this.label();
  });

  readonly hostClass = computed(() => {
    const variant = this.variant();
    if (variant === 'status') {
      return `eventq-badge eventq-badge--status eventq-badge--status-${this.status()}`;
    }
    return `eventq-badge eventq-badge--${variant}`;
  });

  readonly ariaLabel = computed(() => {
    if (this.variant() === 'count') {
      return `Count ${this.count() ?? 0}`;
    }
    return this.displayText();
  });
}
